var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcKrups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 68,
    viewBox: "0 0 35 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3068 31.7824C27.7677 29.9617 31.1246 26.1672 32.3876 21.5195C33.6534 16.8718 32.6776 11.8978 29.7529 8.07245C26.8255 4.24438 22.2836 2 17.4657 2C12.6478 2 8.1061 4.24438 5.17854 8.07245C2.25384 11.8977 1.27802 16.8717 2.54386 21.5195C3.80683 26.1672 7.16371 29.9618 11.6246 31.7824",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.4609H32.9315",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56909 55.5234H29.3631C29.9932 55.5234 30.5982 55.7744 31.0443 56.2205C31.4904 56.6666 31.7414 57.2716 31.7414 57.9044V66.2325L3.19141 66.2297V57.9045C3.19141 56.5886 4.25645 55.5234 5.56962 55.5234L5.56909 55.5234Z",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.413 32.9264C23.413 36.2107 20.7503 38.8733 17.466 38.8733C14.1817 38.8733 11.519 36.2107 11.519 32.9264C11.519 29.6392 14.1817 26.9766 17.466 26.9766C20.7503 26.9766 23.413 29.6392 23.413 32.9264",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8433 38.3828V43.6299C19.8433 44.9431 18.7783 46.0081 17.4651 46.0081C16.152 46.0081 15.0869 44.9431 15.0869 43.6299V38.3828",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75928 29.3555V55.5239",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1719 29.3555V55.5239",
    stroke: "black",
    strokeWidth: 3.3334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKrups);
export default __webpack_public_path__ + "static/media/ic_krups.1650c1a7ad53f06d7051104136a806b0.svg";
export { ForwardRef as ReactComponent };